<template>
  <div>
    <v-img v-if="deck.thumbnail && deck.thumbnail.url"
           :src="deck.thumbnail.url"
           max-width="100%"
           contain
           alt="Thumbnail">
    </v-img>
  </div>
</template>
<script>
export default {
  props: {
    deck: {
      type: Object,
      required: true,
    }
  }
}
</script>
